import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useMe } from "./useAuth";

/**
 * Wrapper für geschützte Routen.
 * - kein User → /login
 * - must_change_password → /change-password (außer wir sind schon dort)
 */
export function RequireAuth({ appName, children }: { appName: string; children: ReactNode }) {
  const loc = useLocation();
  const { data, isLoading, isError } = useMe(appName);
  if (isLoading) return <div className="boot">Lade…</div>;
  if (isError || !data) return <Navigate to="/login" replace />;
  if (data.must_change_password && loc.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  return <>{children}</>;
}
